module.exports = __webpack_public_path__ + "img/down-gansu2.840a4916.jpg";